import { Component, Input, OnInit, EventEmitter, Output, OnChanges, SimpleChanges } from '@angular/core';
import { SearchResultsModel } from 'src/app/models/search-results-model';
import { DialogService } from 'primeng/dynamicdialog';
import { AdamsDocModel } from 'src/app/models/adams-doc-model';
import { ResultColumnsService } from 'src/app/services/result-columns.service';
import { ResultSelectionService } from 'src/app/services/result-selection.service';
import { ReportsDownloadService } from 'src/app/services/reports-download.service';

@Component({
  selector: 'app-results-table-view',
  templateUrl: './results-table-view.component.html',
  styleUrls: ['./results-table-view.component.css']
})
export class ResultsTableViewComponent implements OnInit, OnChanges {

  @Input() viewItems: SearchResultsModel[] = [];
  @Input() loading: boolean = false;
  @Input() totalCount: number = 0;
  @Output() docDetails = new EventEmitter();
  @Output() shareLink = new EventEmitter();
  @Output() addNewCols = new EventEmitter();

  selectedCols: any[] = [];

  showReportDialog: boolean = false;
  showDownloadDialog: boolean = false;

  progress: number = 0;
  cancelDownload = false;
  isDownloading = false;
  isExcelDownload = true;
  downloadFileType: string = 'Excel';
  downloadOption: string = 'all';
  selectedProps: any[] = [];

  tableSelections?: SearchResultsModel;
  allItemsSelected: boolean = false;
  allExceptSelected: boolean = false;

  constructor(public dialogService: DialogService,
    private resultColSvc: ResultColumnsService,
    private selectionSvc: ResultSelectionService,
    public reportsDownloadSvc: ReportsDownloadService
  ) {
  }

  ngOnInit(): void {
    this.allItemsSelected = false;
    //Subscribe to the SelectedCols in the Columns Service
    this.resultColSvc.selectedCols$.subscribe(cols => { this.selectedCols = cols; });
    this.selectionSvc.allSelected$.subscribe(allSelected => { this.allItemsSelected = allSelected; });
    this.selectionSvc.allExcept$.subscribe(allEx => { this.allExceptSelected = allEx; });
  }

  ngOnChanges(changes: SimpleChanges) {
   
  }

  showProperties(item: AdamsDocModel) {
    this.docDetails.emit(item);
  }

  showShare(doc: SearchResultsModel) {
    this.shareLink.emit(doc);
  }

  reorderSortSelections() {
    this.selectedCols.sort((a: any, b: any) => {
      return a.header.localeCompare(b.header);
    });
  }

  //Checkboxes
  toggleAllRows(event: any): void {
    //Set All Selected to the value of the top checkbox
    const isChecked = event.target.checked;
    this.selectionSvc.setAllSelected(isChecked);

    if (!this.allItemsSelected) {
      this.selectionSvc.clearAll();
    }
    else {
      this.selectionSvc.clearExcluded();
      this.selectionSvc.clearSelected();
      this.selectionSvc.setallSelectedWithLegacy(this.viewItems);
    }
  }

  onRowSelectChange(rowData: SearchResultsModel, event: any) {
    const cbxValue = event.target.checked
    rowData.selected = cbxValue;

    if (this.allItemsSelected) {
      this.selectionSvc.setAllSelected(false);
      this.selectionSvc.setAllExcept(true);
      this.selectionSvc.clearExcluded();
    }

    this.setRowSelection(rowData);
  }

  getRowSelection(rowData: SearchResultsModel) {
    return this.selectionSvc.isItemSelected(rowData);
  }

  setRowSelection(rowData: SearchResultsModel) {
    if (rowData.selected) {
      this.selectionSvc.addToSelectedArray(rowData);
    } else {
      if (this.selectionSvc.isAllExcept()) {
        this.selectionSvc.addToExcludedArray(rowData);
      }
      else {
        this.selectionSvc.removeFromSelectedArray(rowData);
      }
    }
  }
}
